<!-- Begin: Admin Form -->
<div class="mw1200 center-block">
    <div class="admin-form">

        <div class="panel heading-border">
            <div class="panel-body bg-light">
                <form ngNativeValidate [formGroup]="forma" (ngSubmit)="createCustomer()" method="post" id="form-ui">
                    <div class="section-divider mb40" id="spy1">
                        <span>Customer Form</span>
                    </div>
                    <!-- .section-divider -->

                    <!-- Basic Inputs -->
                    <div class="row">



                        <div class="col-md-8 ">

                            <div class="row ">
                                <div class="col-md-6">
                                    <div class="section ">


                                        <mat-form-field class="example-full-width">
                                          <mat-label>Company</mat-label>
                                          <input matInput formControlName="companyname" name="companyname" id="companyname">
                                        </mat-form-field>


                                    </div>
                                </div>
                                <div class="col-md-6">
                                  <div class="section ">


                                      <mat-form-field class="example-full-width">
                                        <mat-label>Id</mat-label>
                                        <input matInput formControlName="identification" name="identification" id="identification">
                                      </mat-form-field>


                                  </div>
                              </div>
                            </div>

                            <div class="row ">
                                <div class="col-md-6 ">
                                    <div class="section ">


                                        <mat-form-field class="example-full-width">
                                          <mat-label>Firstname</mat-label>
                                          <input matInput formControlName="firstnamecontact" name="firstnamecontact" id="firstnamecontact">
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-md-6 ">
                                    <div class="section ">


                                        <mat-form-field class="example-full-width">
                                          <mat-label>Lastname</mat-label>
                                          <input matInput formControlName="lastnamecontact" name="lastnamecontact" id="lastnamecontact">
                                        </mat-form-field>


                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="section ">



                                          <app-google-places (setAddress)="getAddress($event)" adressType="geocode"></app-google-places>


                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="section ">

                                        <mat-form-field class="example-full-width">
                                          <mat-label>Region</mat-label>
                                          <input matInput formControlName="region" name="region" id="region" readonly>
                                        </mat-form-field>

                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">

                                    <div class="section ">


                                    <mat-form-field class="example-full-width">

                                      <mat-label>Select type</mat-label>

                                      <mat-select formControlName="typeuser" [(ngModel)]="selectedType">

                                        <mat-option value="0">Customer


                                      </mat-option>
                                      </mat-select>

                                      <mat-error *ngIf="forma.controls.typeuser.hasError('required')">You must make a selection</mat-error>

                                    </mat-form-field>


                                    </div>
                                </div>
                                <div class="col-md-6">


                                    <div class="section ">


                                        <mat-form-field class="example-full-width">
                                          <mat-label>Email</mat-label>
                                          <input matInput formControlName="email" name="email" id="email">

                                        <mat-error  *ngIf="forma.controls['email'].invalid && forma.touched">
                                          Email is <strong>required</strong>
                                        </mat-error>

                                      </mat-form-field>

                                    </div>
                                </div>
                            </div>





                            <div class="row">
                                <div class="col-md-6">
                                    <div class="section ">

                                        <mat-form-field class="example-full-width">
                                          <mat-label>Phone</mat-label>
                                          <input matInput formControlName="phone" name="phone" id="phone">
                                        </mat-form-field>

                                    </div>
                                    <!--
                                    <div class="section ">

                                        <label class="field select ">
                                          <select id="country " formControlName="typeuser" name="typeuser ">
                                          <option value=" ">Select with single arrow</option>
                                          <option value="AL ">Albania</option>
                                          <option value="DZ ">Algeria</option>
                                          </select>
                                          <i class="arrow "></i>
                                      </label>
                                    </div>
                                    -->
                                </div>
                                <div class="col-md-6">
                                    <div class="section">



                                        <mat-form-field class="example-full-width">

                                          <mat-label>Status</mat-label>
                                          <mat-select formControlName="status"  [(ngModel)]="selectedStatus">

                                               <mat-option value="0">Inactive </mat-option>
                                              <mat-option value="1">Active  </mat-option>
                                          </mat-select>

                                          <mat-error *ngIf="forma.controls.status.hasError('required')">You must make a selection</mat-error>

                                        </mat-form-field>


                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <div class="section ">


                                        <mat-form-field class="example-full-width">
                                          <mat-label>Hour to</mat-label>
                                          <input matInput  formControlName="houropen" id="houropen" name="houropen" [ngxTimepicker]="horapicker2">
                                          <ngx-material-timepicker #horapicker2></ngx-material-timepicker>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="section ">


                                        <mat-form-field class="example-full-width">
                                          <mat-label>Hour from</mat-label>
                                          <input matInput  formControlName="hourclose" id="hourclose" name="hourclose" [ngxTimepicker]="horapicker">
                                          <ngx-material-timepicker #horapicker></ngx-material-timepicker>
                                        </mat-form-field>

                                    </div>
                                </div>

                            </div>


                            <div class="row">
                                <div class="col-md-12">


                                    <mat-form-field class="example-full-width">
                                      <mat-label>Leave a comment</mat-label>
                                      <textarea matInput placeholder="Description customer or reference..." formControlName="description" id="description" name="description" rows=3></textarea>
                                    </mat-form-field>

                                </div>

                            </div>

                            <div class="row">


                            </div>

                        </div>
                        <div class="col-md-4" style="margin-bottom:30px">
                            <div #mapContainer id="map"></div>
                        </div>

                    </div>










                    <!--   <div class="section-divider mt40 mb25 " id="spy6 ">
                  <span>Toggle Switches</span>
              </div>


              <div class="section row ">
                  <div class="col-md-6 col-md-3 ">
                      <label class="switch block mt15 ">
<input type="checkbox " name="features " id="f1 " value="javascript ">
<label for="f1 " data-on="ON " data-off="OFF "></label>
                      <span>Javascript</span>
                      </label>
                      <label class="switch block mt15 ">
<input type="checkbox " name="features " id="f2 " value="downloads ">
<label for="f2 " data-on="ON " data-off="OFF "></label>
                      <span>Downloads</span>
                      </label>
                      <label class="switch block mt15 ">
<input type="checkbox " name="features " id="f3 " value="cookies ">
<label for="f3 " data-on="ON " data-off="OFF "></label>
                      <span>Cookies</span>
                      </label>
                      <label class="switch block mt15 ">
<input type="checkbox " name="features " id="f4 " value="popups " checked>
<label for="f4 " data-on="ON " data-off="OFF "></label>
                      <span>Popups</span>
                      </label>
                  </div>


                  <div class="hidden-xs col-md-3 ">
                      <label class="switch block mt15 ">
<input type="checkbox " name="tools " id="t1 " value="analytics ">
<label for="t1 " data-on="YES " data-off="NO "></label>
                      <span>Analytics</span>
                      </label>
                      <label class="switch block mt15 ">
<input type="checkbox " name="tools " id="t2 " value="reports ">
<label for="t2 " data-on="YES " data-off="NO "></label>
                      <span>Reports</span>
                      </label>
                      <label class="switch block mt15 ">
<input type="checkbox " name="tools " id="t3 " value="social ">
<label for="t3 " data-on="YES " data-off="NO "></label>
                      <span>Social</span>
                      </label>
                      <label class="switch block mt15 ">
<input type="checkbox " name="tools " id="t4 " value="admin " checked>
<label for="t4 " data-on="YES " data-off="NO "></label>
                      <span>Access</span>
                      </label>
                  </div>


                  <div class="col-md-6 col-md-3 ">
                      <label class="switch switch-round block mt15 ">
<input type="radio " name="framework " id="fr1 " value="mootols ">
<label for="fr1 " data-on="ON " data-off="OFF "></label>
                      <span>MooTools</span>
                      </label>
                      <label class="switch switch-round block mt15 ">
<input type="radio " name="framework " id="fr2 " value="angular ">
<label for="fr2 " data-on="ON " data-off="OFF "></label>
                      <span>Angular JS</span>
                      </label>
                      <label class="switch switch-round block mt15 ">
<input type="radio " name="framework " id="fr3 " value="jquery ">
<label for="fr3 " data-on="ON " data-off="OFF "></label>
                      <span>jQuery</span>
                      </label>
                      <label class="switch switch-round block mt15 ">
<input type="radio " name="framework " id="fr4 " value="dojo " checked>
<label for="fr4 " data-on="ON " data-off="OFF "></label>
                      <span>Dojo</span>
                      </label>
                  </div>


                  <div class="hidden-xs col-md-3 ">
                      <label class="switch switch-round block mt15 ">
<input type="radio " name="framework2 " id="fr5 " value="mootols ">
<label for="fr5 " data-on="YES " data-off="NO "></label>
                      <span>MooTools</span>
                      </label>
                      <label class="switch switch-round block mt15 ">
<input type="radio " name="framework2 " id="fr6 " value="angular ">
<label for="fr6 " data-on="YES " data-off="NO "></label>
                      <span>Angular JS</span>
                      </label>
                      <label class="switch switch-round block mt15 ">
<input type="radio " name="framework2 " id="fr7 " value="jquery ">
<label for="fr7 " data-on="YES " data-off="NO "></label>
                      <span>jQuery</span>
                      </label>
                      <label class="switch switch-round block mt15 ">
<input type="radio " name="framework2 " id="fr8 " value="dojo " checked>
<label for="fr8 " data-on="YES " data-off="NO "></label>
                      <span>Dojo</span>
                      </label>
                  </div>

              </div> -->
                    <!-- end .section row section -->


                    <!-- end .form-body section -->
                    <div class="panel-footer text-center ">
                        <button type="submit" [disabled]="!forma.valid" class="button btn-primary ">Save</button>
                    </div>
                    <!-- end .form-footer section -->
                </form>
            </div>
        </div>

    </div>
</div>
